import { routes } from "@/consts";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { LANG } from "@/types";
import { Languages } from "lucide-react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ResetPasswordForm from "./components/reset-password-form-view";
import {
  Container,
  Paper,
  Typography,
  Box,
  useTheme,
  IconButton,
  Tooltip,
} from "@mui/material";

export default function ResetPasswordPage() {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [searchParams] = useSearchParams();
  const emailForgetPassword = sessionStorage.getItem("emailForgotPassword");
  const code = searchParams.get("code");
  const theme = useTheme();
  const getNextLocale = () => {
    return locale === LANG.EN ? LANG.AR : LANG.EN;
  };
  const handleLanguageSwap = () => {
    const pathName = location.pathname;
    const searchParams = location.search;
    if (!pathName) return routes.home;
    const segments = pathName.split("/");
    segments[1] = getNextLocale();
    return segments.join("/") + searchParams;
  };
  const navigate = useNavigate();
  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: { xs: 4, sm: 8 },
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          p: { xs: 3, sm: 5 },
          borderRadius: 3,
          bgcolor: theme.palette.background.paper,
        }}
      >
        <Box sx={{ mb: 3, textAlign: "center" }}>
          <Typography
            variant="h4"
            fontWeight={700}
            sx={{ mb: 1, color: "black" }}
          >
            {t("authentication.messages.resetPassword")}
          </Typography>
          {emailForgetPassword && (
            <Typography
              variant="body2"
              sx={{ color: theme.palette.text.secondary }}
            >
              {t("authentication.messages.sendTokenToEmail")}{" "}
              <Box
                component="span"
                sx={{ color: theme.palette.secondary.main, fontWeight: 600 }}
              >
                {emailForgetPassword}
              </Box>
            </Typography>
          )}
        </Box>
        <ResetPasswordForm
          token={code ?? ""}
          email={emailForgetPassword ?? ""}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 4,
          }}
        >
          <Tooltip title={locale === LANG.AR ? "English" : "عربي"}>
            <IconButton onClick={() => navigate(handleLanguageSwap())}>
              <Languages size={20} />
              <Typography sx={{ ml: 1 }}>
                {locale === LANG.AR ? "عربي" : "english"}
              </Typography>
            </IconButton>
          </Tooltip>
          <Typography variant="body2" className="!text-[#644999]">
            <Link
              to={routes.login}
              style={{
                textDecoration: "none",
                fontWeight: 600,
              }}
            >
              {t("authentication.login")}
            </Link>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}
